import React from "react";
import { Modal } from "react-bootstrap";
import "../../../styles/newStyles/headerModal.scss";

export const HeaderLocationModal = (props) => {
  const { modalStatus, setModalStatus, heading, modalBody, modalFooter } = props;

  return (
    <Modal show={modalStatus} onHide={setModalStatus}>
      <Modal.Header closeButton>
        <Modal.Title>{heading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          modalBody
        }
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        {
          modalFooter
        }
      </Modal.Footer>
    </Modal>
  );
};
